import { h } from 'preact';
import { useState, useRef, useEffect } from 'preact/hooks';
import styles from './SortDropdown.module.scss';
export function SortDropdown({ options = [], onChange, totalProductCount = 0, variant = 'desktop', currentSort, }) {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const dropdownRef = useRef(null);
    useEffect(() => {
        if (options.length > 0) {
            if (currentSort) {
                const matchingOption = options.find(option => option.id === currentSort);
                if (matchingOption) {
                    setSelectedOption(matchingOption);
                }
                else {
                    setSelectedOption(options[0]);
                }
            }
            else {
                setSelectedOption(options[0]);
            }
        }
    }, [options, currentSort]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current &&
                !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const handleSelect = (option) => {
        setSelectedOption(option);
        onChange(option.id);
        setIsOpen(false);
    };
    return (h("div", { className: `${styles.sortContainer} ${styles[variant]}` },
        h("div", { className: styles.totalProducts }, options.length === 0 ? (
        // Show placeholder while loading to prevent CLS
        "Loading...") : totalProductCount > 0 ? (`${totalProductCount} ${totalProductCount === 1 ? 'Product' : 'Products'}`) : ("0 Products")),
        h("div", { className: styles.sortDropdownContainer },
            h("div", { className: styles.sortLabel }, "Sort By:"),
            h("div", { className: styles.dropdownContainer, ref: dropdownRef },
                h("button", { className: styles.dropdownButton, onClick: options.length > 0 ? () => setIsOpen(!isOpen) : undefined, "aria-expanded": isOpen, disabled: options.length === 0 },
                    h("span", null, options.length === 0
                        ? 'Loading...'
                        : (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || 'Select...'),
                    h("svg", { width: "20", height: "21", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: `${styles.dropdownIcon} ${isOpen ? styles.rotated : ''}` },
                        h("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.41554 8.19922L10.0002 13.4502L15.5849 8.19922L16.2852 8.91159L10.3595 14.4796L10.3586 14.4805L10.0002 14.8155L9.64183 14.4805L9.6409 14.4796L3.71529 8.91159L4.41554 8.19922Z", fill: "#262525" }))),
                isOpen && options.length > 0 && (h("div", { className: styles.dropdownMenu }, options.map((option) => (h("button", { key: option.id, className: `${styles.dropdownItem} ${option.id === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id) ? styles.selected : ''}`, onClick: () => handleSelect(option) }, option.label)))))))));
}
